import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "table-cell-content"
}

import { BaseTableContentViewModel } from '../../baseTableContentViewModel';
import { EditBusinessHeaderKey, TableContentProperty } from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import EditBusinessButton from './EditBusinessButton.vue';
import TableCell from '../TableCell.vue';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditBusinessTableCell',
  props: {
    header: {},
    editBusinessHeaderKey: {},
    item: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    isEditing: { type: Boolean },
    isBold: { type: Boolean },
    isChecked: { type: Boolean },
    isCheckedBusinessId: { type: Boolean }
  },
  emits: ["onClickNarrow"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const baseTableContentViewModel = new BaseTableContentViewModel();

const headerItemPath = computed(() => {
  if (!props.header.propertyPath) return '--';
  let buf = props.item;
  props.header.propertyPath.paths.forEach((path) => {
    buf = buf[path];
  });
  return buf ?? '--';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableCell, {
    class: _normalizeClass([[_unref(baseTableContentViewModel).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : ''], "table-cell base-table__body--fixed"]),
    style: _normalizeStyle({
      left: _unref(baseTableContentViewModel).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth),
    }),
    "text-align": "left",
    "table-content-property": _ctx.header,
    "is-highlighted": props.isChecked || props.isCheckedBusinessId
  }, {
    default: _withCtx(() => [
      (_ctx.header.key === 'editBusiness')
        ? (_openBlock(), _createBlock(EditBusinessButton, {
            key: 0,
            class: "edit-business",
            item: _ctx.item
          }, null, 8, ["item"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(headerItemPath.value), 1))
    ], undefined, true),
    _: 1
  }, 8, ["class", "style", "table-content-property", "is-highlighted"]))
}
}

})